var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data && _vm.data.length)?_c('div',{staticClass:"grid 2xl:grid-cols-4 xl:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4"},_vm._l((_vm.data),function(d,i){return _c('div',{key:i},[(d.entity_type==1)?_c('router-link',{attrs:{"to":{
        name: 'UserSessionDetails',
        params: { id: d.id },
      }}},[_c('Card',{attrs:{"data":d}})],1):_vm._e(),(d.entity_type==2)?_c('router-link',{attrs:{"to":{
        name: 'UserCourseDetails',
        params: { id: d.id },
      }}},[_c('Card',{attrs:{"data":d}})],1):_vm._e()],1)}),0):_c('span',{staticClass:"text-xs text-gray-700"},[_vm._v("No data found.")])
}
var staticRenderFns = []

export { render, staticRenderFns }